interface IconBookingStatusCheckOptions {
    cssClasses? : string
}

export function IconBookingStatusCheck(props : IconBookingStatusCheckOptions) {
    return (
        <svg id="e87924d6-99de-403d-8388-9e78b7072866" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className={props?.cssClasses}>
            <defs>
                <clipPath id="ba7bbf7d-9856-44be-954f-d1faf363d741" transform="translate(0)">
                    <rect className="b3ea9683-9365-4b5d-b9bf-39c436f43871" width="16" height="16"/>
                </clipPath>
            </defs>
            <g className="e4e6ae60-232b-4801-94d5-7197f221326a">
                <path className="a0e061d9-7348-4835-868b-16f32b5e3251" d="M6.67,11.33a.67.67,0,0,1-.47-.19L3.53,8.47a.66.66,0,0,1,0-.94.68.68,0,0,1,1,0L6.67,9.72l4.86-4.86a.68.68,0,0,1,1,0,.66.66,0,0,1,0,.94L7.14,11.14A.67.67,0,0,1,6.67,11.33Z" transform="translate(0)"/>
                <path className="a0e061d9-7348-4835-868b-16f32b5e3251" d="M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM8,1.33A6.67,6.67,0,1,0,14.67,8,6.68,6.68,0,0,0,8,1.33Z" transform="translate(0)"/>
            </g>
        </svg>
    );
}
